<template>

  <popup-modal ref="popup">
            <v-card>
              <v-toolbar color="primary" dark>
                {{title}}
              </v-toolbar>

                <v-card-text class="mt-4">{{message}}</v-card-text>

<!--                Actions-->
                <v-card-actions>
                    <div class="flex-grow-1"></div>

                    <v-btn @click="Negative" text >{{negative}}</v-btn>
                    <v-btn @click="Positive" color="primary">{{positive}}</v-btn>
                </v-card-actions>

            </v-card>
  </popup-modal>

</template>


<script>
    import PopupModal from "@/components/PopupModal";

    export default {
        components: { PopupModal },
        data: () => ({
          title: undefined,
          message: undefined,
          positive: undefined,
          negative: undefined,

          // Private variables
          resolvePromise: undefined,
          rejectPromise: undefined,
        }),
        methods:{
          show(opts = {}) {
            this.title = opts.title
            this.message = opts.message
            this.positive = opts.positive
            this.negative = opts.negative

            // Once we set our config, we tell the popup modal to open
            this.$refs.popup.open(false, true)

            // Return promise so the caller can get results
            return new Promise((resolve, reject) => {
              this.resolvePromise = resolve
              this.rejectPromise = reject
            })
          },


            Positive(){
              this.$refs.popup.close()
              this.resolvePromise({answer: 'positive'})
            },
            Negative(){
              this.$refs.popup.close()
              this.resolvePromise({answer: 'negative'})
            },
        },
    };
</script>
